import React, { useContext, useEffect, useState } from "react";
import { Box, Button, Checkbox, CircularProgress, Dialog, DialogContent, FormControl, FormControlLabel, FormGroup, IconButton, InputLabel, MenuItem, Select, TextField, Typography, Fab, DialogActions, Tabs, Tab, Autocomplete, Divider, Chip } from "@mui/material";
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import DeleteIcon from '@mui/icons-material/Delete';
import Tooltip from "@mui/material/Tooltip";
import { Check as CheckIcon, Clear as ClearIcon, Close, CropSharp, Details } from "@mui/icons-material";
import { CloseOutlined } from "@mui/icons-material";
import { Stack } from "@mui/material";
import styled from "styled-components";
import { ACTIVITY_STATUS, ROLES } from "../../constants";
import moment from "moment";
import OpaqueLoading from "../opaqueLoading/opaqueLoading";
import { DataGrid, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton } from "@mui/x-data-grid";
import { AuthContext } from "../contextAPI/ContextAPI";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import MakeVisitRouteModal from "./MakeVisitRouteModal";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";
import { param } from "jquery";
const isMobile = window.innerWidth < 900;
const TotalAmountTypography = styled(Typography)`
  position: absolute;
  bottom: 10px;
  right: 10px;
  font-size: ${isMobile ? "14px" : "inherit"};
  bottom: ${isMobile ? "85px" : "70px"};
  right: ${isMobile ? "15px" : "70px"};
`;
const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 10px;
`;
const TableContainer = styled.div`
  // height: calc(
  //   100vh - ${isMobile ? "106px - 20px - 82.23px" : "100px - 20px - 23.77px"}
  // );
  width: ${isMobile ? "100%" : "98%"};
  // border: solid 1px lightGrey;
  border-radius: 8px;
  margin-left:${isMobile ? "0px" : "10px"};
  margin-bottom:${isMobile ? "0px" : "10px"};
`;
const InputFieldContainer = styled.div`
  margin: 20px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  label {
    margin-bottom: 0px;
  }`;
const TabsContainer = styled.div`
  ${isMobile && `
    height: calc(100vh - 176px - 20px - 43.77px);
  `}`
const StyledTabs = styled(Tabs)`
  border-bottom: solid 1px lightGrey;
`;
const ModalActionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
`;
const FirstButton = styled(Button)`
  margin-right: 10px !important;
`;
const StyledDialogContent = styled(DialogContent)`
  padding: 16px;
`;
const StyledDialog = styled(Dialog)`
  position: relative;
`;
const FabStyle = styled(Fab)`
  && {
    z-index: 1;
  }
`;
const DataGridContainer = styled.div`
  width: 100%;
`;
const DataGridContainer1 = styled.div`
  width: 100%;
  margin-bottom:${!isMobile && "20px"};
 
//   height: 500px;
`;
const NoteText = styled(Typography)`
  margin-top: 10px !important;
`;
const Input = styled.input`
  display: none;
`;

const PartyListModalAddNewRoute = ({ onClose, routeId, routeDate, ownerId, getRouteplanById }) => {

  const [rm, setRm] = useState("")
  const [rsm, setRsm] = useState("")
  const [asm, setAsm] = useState("")
  const [rsms, setRsms] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [asms, setAsms] = useState([]);
  const [rms, setRms] = useState([]);
  const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)
  const [visitType, setVisitType] = useState([])
  const [form, setForm] = useState({})
  const [loading, setLoading] = useState(false);
  const [schools, setSchools] = useState([]);
  const [distributors, setDistributors] = useState([]);


  useEffect(() => {
    if (userData?.role.toLowerCase().includes('admin')) {
      getAllUsers()
    }
    if (userData?.role == 'rsm') {
      getUsers('rsm', userData?.id)
    }
    if (userData?.role == 'asm') {
      getUsers('asm', userData?.id)
    }
    getRouteVisitType()
  }, [])

  console.log(form, "form data in route plan modal");
  const getRouteVisitType = async (details) => {
    try {
      setLoading(true)
      let results = await window.Platform.database.getRouteVisitType(details);
      setVisitType(results.data)
      setLoading(false)
    }
    catch (err) {
      console.log(err);
      setLoading(false)
    }
  }
  // console.log(routeId, routeDate, ownerId,"routeId, routeDate, ownerId,")

  const changeHandler = (fieldName, value) => {
    setForm((prevForm) => ({ ...prevForm, [fieldName]: value }));
  };

  const getSchool = async () => {
    setLoading(true);
    try {
      const res = await window.Platform.database.getAllSchool({ ownerId: ownerId });
      setSchools(res.data || []);
    } catch (err) {
      window.NotificationUtils.showError("Failed to fetch schools");
    }
    setLoading(false);
  };

  const getDistributor = async () => {
    setLoading(true);
    try {
      const res = await window.Platform.database.getAllDistri({ ownerId: ownerId });
      setDistributors(res.data || []);
    } catch (err) {
      window.NotificationUtils.showError("Failed to fetch distributors");
    }
    setLoading(false);
  };

  useEffect(() => {
    if (form.partyName === "school") {
      getSchool();
      setForm(prev => ({ ...prev, partyId: "" }));
    } else if (form.partyName === "distributor") {
      getDistributor();
      setForm(prev => ({ ...prev, partyId: "" }));
    }
  }, [form.partyName]);

  async function getAllUsers() {
    let results = await window.Platform.database.fetchEmployees()
    setAllUsers(results?.data)
    setRsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'rsm'))
    setRms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
    setAsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'asm'))
  }

  async function getUsers(role, id) {
    if (id != "") {
      let results = await window.Platform.database.getUsersBasedOnManager({ userId: id })
      if (role == 'rsm') {
        setAsms(results?.data)
        setRms(results?.data1)
      }
      if (role == 'asm') {
        setRms(results?.data)
      }
    } else {
      if (role == 'rsm') {
        setRm("")
        setAsm("")
        setRms(allUsers?.filter((ele) => ele.role == 'se'))
        setAsms(allUsers?.filter((ele) => ele.role == 'asm'))
      }
      if (role == 'asm') {
        setRm("")
        setRms(allUsers?.filter((ele) => ele.role == 'se'))
      }
    }
  }

  const handleSubmit = async () => {
    setLoading(true);
    try {
      if (!form.partyName || !form.partyId || !form.visitType) {
        window.NotificationUtils.showError("Please fill all the fields");
        setLoading(false);
        return;
      }
      const payload = {
        ...form,
        routeId: routeId,
        routeDate: routeDate,
        ownerId: ownerId,
      };
      const response = await window.Platform.database.addRoutePlan(payload);
      if (response.status === 200) {
        window.NotificationUtils.showSuccess("Route Plan added successfully");
        getRouteplanById(routeId);
        onClose();
      } else {
        window.NotificationUtils.showError("Failed to add Route Plan");
      }
    } catch (error) {
      console.error("Error adding Route Plan:", error);
      window.NotificationUtils.showError("An error occurred while adding Route Plan");
    } finally {
      setLoading(false);
    }
  }


  const renderContent1 = () => {
    return (
      <>
        {/* <Stack direction={"row"} spacing={2} padding={2}>

        {userData?.role.includes('admin') && <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
          <InputLabel id="select-label">Select HO</InputLabel>
          <Select
            labelId="select-label"
            id="select"
            value={rsm}
            onChange={(e) => { setRsm(e.target.value); getUsers('rsm', e.target.value) }}
            label="Select HO"
          >
            <MenuItem value="">All</MenuItem>
            {rsms.map((role) => (<MenuItem key={role} value={role.id}>{role.name}</MenuItem>))}
          </Select>
        </FormControl>}

        {userData?.role != 'asm' && <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
          <InputLabel id="select-label">Select ARM</InputLabel>
          <Select
            labelId="select-label"
            id="select"
            value={asm}
            onChange={(e) => { setAsm(e.target.value); getUsers('asm', e.target.value) }}
            label="Select ARM"
          >
            <MenuItem value="">All</MenuItem>
            {asms.map((role) => (<MenuItem key={role} value={role.id}>{role.name}</MenuItem>))}
          </Select>
        </FormControl>}

        <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
          <InputLabel id="select-label">Select RM</InputLabel>
          <Select
            labelId="select-label"
            id="select"
            value={rm}
            onChange={(e) => { setRm(e.target.value); getUsers('rm', e.target.value) }}
            label="Select ARM"
          >
            <MenuItem value="">All</MenuItem>
            {rms.map((role) => (<MenuItem key={role} value={role.id}>{role.name}</MenuItem>))}
          </Select>
        </FormControl>
      </Stack> */}


        <Stack direction={"row"} spacing={2} padding={2}>

          <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
            <InputLabel id="select-label">Route Visit Type</InputLabel>
            <Select
              labelId="select-label"
              id="select"
              value={form.visitType || ""}
              onChange={(e) => changeHandler("visitType", e.target.value)}
              label="Route Visit Type"
            >
              {visitType?.map((option, optionIndex) => (
                <MenuItem key={option.routeVisitTypeID} value={option.routeVisitTypeID}>
                  {option.routeVisitType}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

        </Stack>
        <Stack direction={"row"} spacing={2} padding={2}>
          <Stack direction={"row"} spacing={2} sx={{ width: "100%" }}>
            <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
              <InputLabel >Select Party</InputLabel>
              <Select
                labelId={`Party`}
                label="Select Party"
                value={form?.partyName || ""}
                onChange={(e) => changeHandler('partyName', e.target.value)}
              >
                <MenuItem value="" hidden>
                  Select Party
                </MenuItem>
                <MenuItem value="school">
                  School
                </MenuItem>
                <MenuItem value="distributor">
                  Distributor
                </MenuItem>
              </Select>
            </FormControl>

          </Stack>

          <Stack direction={"row"} spacing={2} sx={{ width: "100%" }}>
            {form?.partyName == "school" && <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
              <InputLabel >Select School</InputLabel>
              <Select
                labelId="selectSchool"
                label="Select School"
                value={form?.partyId || ""}
                onChange={(e) => changeHandler('partyId', e.target.value)}
              >
                {schools && schools?.map((ele, ind) => {
                  return (
                    <MenuItem key={ind} value={ele.schoolId}>
                      {ele.schoolName}
                    </MenuItem>
                  )
                })}
              </Select>
            </FormControl>}

            {form?.partyName == "distributor" && <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
              <InputLabel >Select Distributor</InputLabel>
              <Select
                labelId="selectDistributor"
                label="Select Distributor"
                value={form?.partyId || ""}
                onChange={(e) => changeHandler('partyId', e.target.value)}
              >
                {distributors && distributors?.map((ele, ind) => {
                  return (
                    <MenuItem key={ind} value={ele.distributorID}>
                      {ele.DistributorName}
                    </MenuItem>
                  )
                })}
              </Select>
            </FormControl>}
          </Stack>
        </Stack>

        <Stack direction="row" justifyContent="center" alignItems="center" padding={2}>
          <Button variant="contained" color="primary" disabled={!form?.partyName || !form?.partyId || !form?.visitType} onClick={() =>{handleSubmit()}}>
            Submit
          </Button>
        </Stack>
      </>
    )
  }

  return (
    <>
      <Dialog disableEnforceFocus maxWidth="md" fullWidth={true} open={true} >
        {loading && <OpaqueLoading />}
        <ModalHeaderContainer style={{ marginBottom: 2, paddingBottom: 3 }}>
          <Typography variant={isMobile ? "h6" : "h5"}>
            Add Route-Plan
          </Typography>
          <IconButton onClick={onClose} ><CloseOutlined /></IconButton>
        </ModalHeaderContainer>
        <TableContainer>
          <TabsContainer>
            <StyledTabs variant="fullWidth" indicatorColor="primary" textColor="primary">
              <Tab label="Route Details" />
            </StyledTabs>
            {renderContent1()}
          </TabsContainer>
        </TableContainer>
      </Dialog>
    </>
  );
};

export default PartyListModalAddNewRoute;